import { template } from 'lodash';

window.Reverb = window.Reverb || {};
Reverb.Listing = Reverb.Listing || {};

Reverb.Listing.AddShippingRate = (function () {
  const shipsFromCountryField = '[data-ships-from-country]';
  const regionSelectField = '[data-bind=\'new-shipping-rate-region\']';
  const regionChosenField = `${regionSelectField} + .chzn-container`;
  const existingRates = '[data-bind=\'existing-shipping-rates\']';
  const shippingRatesContainer = '[data-bind=\'product-shipping-fields\']';

  function regionCode() {
    return $(regionSelectField).val();
  }

  function regionName() {
    return selectedRegion().text();
  }

  function regionType() {
    return selectedRegion().data('region-type');
  }

  function selectedRegion() {
    return $(regionSelectField).find('option:selected');
  }

  function validToAdd() {
    const regionValid = $(regionSelectField).val().length > 0;

    if (!regionValid) { $(regionChosenField).addClass('ui-state-error'); }

    return regionValid;
  }

  function resetForm() {
    $(regionSelectField).find('option').first().attr('selected', true);
    $(regionSelectField).trigger('liszt:updated');
  }

  function addShippingRate() {
    // TODO: audit
    const tpl = template($('#new-rate-template').html());

    const newRate = $(tpl({
      country_name: regionName(),
      region_code: regionCode(),
      region_type: regionType(),
    }));

    selectedRegion().attr('disabled', true);

    newRate.hide();
    $('[data-new-row]').before(newRate);
    resetForm();
    newRate.fadeIn();
  }

  function countryChanged() {
    const $container = $(shippingRatesContainer);
    const url = `${$container.data('load-from-url')}?${$.param({
      country_code: $(shipsFromCountryField).val(),
    })}`;
    $container.load(url, () => {
      removeInitialRates();
      addNewLocationTooltips();
    });
  }

  function removeInitialRates() {
    $(existingRates).find('[data-shipping-rate-region]').each((i, element) => {
      const regionType = $(element).find('[data-region-type]').val();


      const regionCode = $(element).find('[data-region-code]').val();

      toggleRegionOption(regionType, regionCode, false);
    });
  }

  function toggleRegionOption(regionType, regionCode, enabled) {
    const regionOption = $(regionSelectField).find(`[data-region-type='${regionType}'][value='${regionCode}']`);

    regionOption.attr('disabled', !enabled);
    resetForm();
  }

  function bindAddShippingRate() {
    $(document).on('click', '[data-bind=\'add-shipping-rate\']', (e) => {
      e.preventDefault();

      if (validToAdd()) {
        addShippingRate();
      }
    });
  }

  function addNewLocationTooltips() {
    const newElementsWithTips = $(`${shippingRatesContainer} .tooltip`);

    $(newElementsWithTips).each(function () {
      $(this).powerTip();
    });
  }

  function bindChangeCountry() {
    $(document).on('change', shipsFromCountryField, countryChanged);
  }

  function bindRemoveShippingRate() {
    const regionCodeSelector = '[data-disable-region-code]';

    $(document).on('click', regionCodeSelector, (event) => {
      const regionType = $(event.target).data('disable-region-type');
      const regionCode = $(event.target).data('disable-region-code');

      toggleRegionOption(regionType, regionCode, true);
    });
  }

  function init() {
    bindAddShippingRate();
    bindChangeCountry();
    bindRemoveShippingRate();
    removeInitialRates();
  }

  return {
    init,
  };
}());

$(Reverb.Listing.AddShippingRate.init);
